// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"223":"commons","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"223":"36e85f6595d7a990001f","245":"c9d811dd7c1ee992b978","453":"d1232d6d09ca7976adab","554":"a2233cea8a9a27dc6594"}[chunkId] + ".js";
};